import React from "react";
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { IFilter } from "./TicektList";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangePicker";
import { tw } from "@careinfo/tailwind";
import { classNames } from "../Reusable/DatePicker/helpers";
import APIS from "../../constant/Endpoint";
interface Props {
  register: UseFormRegister<IFilter>;
  errors: FieldErrors<IFilter>;
  setValue: UseFormSetValue<IFilter>;
  getValues: UseFormGetValues<IFilter>;
  reset: UseFormReset<IFilter>;
  watch: UseFormWatch<IFilter>;
  clearErrors: UseFormClearErrors<IFilter>;
  control: Control<IFilter>;
  isFilterVisible: boolean;
}

const TicketFilter = (props: Props) => {
  const { register, errors, setValue, getValues, clearErrors, control, reset } =
    props;

  return (
    <div
      className={classNames(
        props?.isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      <div className={tw`grid grid-cols-4 gap-x-4 mx-4`}>
        <DateRangePicker
          label={"Date Range"}
          setValue={setValue}
          name={"created__range"}
          getValues={getValues}
        />
        <ComboboxFilter
          url={APIS.SUBJECT}
          queryKey={"queue"}
          register={register("queue")}
          errors={errors?.queue}
          name={"queue"}
          label={"Subject"}
          setValue={setValue}
          params={{
            is_active: true,
          }}
          placeholder={"Select Subject"}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
        <ComboboxFilter
          url={`${APIS.TICKET}available-priority/`}
          queryKey={"prority"}
          register={register("priority")}
          errors={errors?.priority}
          name={"priority"}
          label={"Priority"}
          setValue={setValue}
          params={{
            is_active: true,
          }}
          placeholder={"Select Priority"}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
        <ComboboxFilter
          url={`${APIS.TICKET}available-status/`}
          queryKey={"status"}
          register={register("status")}
          errors={errors?.status}
          name={"status"}
          label={"Status"}
          setValue={setValue}
          params={{
            is_active: true,
          }}
          placeholder={"Select Status"}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
        <button
          className={tw`absolute -top-5 right-5 focus:outline-none`}
          onClick={() => reset()}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default TicketFilter;
